@if (isMobileView && (widgetDataStore.widgets$ | async)?.length) {
  <swiper-container appSwiper #swiper animate.enter="adx-fade-in" [config]="swiperConfig" class="swiper-mobile-container" events-prefix="swiper-" init="false" (swiper-slidechange)="onSwiperSlideChange()">
    @for (widget of widgetDataStore.widgets$ | async; track widget._id) {
      <swiper-slide
        (touchstart)="onWidgetHover(widget)"
        #widgetItems
        >
        @if (renderWidgetHeader(widget)) {
          <!-- no fullscreen action here: the swiper already shows one widget at a time -->
          <app-widget-header class="swiper-slide-mobile-header"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed,
            'adx-header-shown': widgetHeaderIsHovered(widget)
            }"
            [widget]="widget"
            variant="swiper"
            (menuOpenChange)="onWidgetMenuOpenChange(widget, $event)"
            >
          </app-widget-header>
        }
        @if (showWidgetDivider(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="swiper-item-content" [class.adx-header-hover-mode]="widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed" [class.adx-header-overlaid]="widgetHeaderIsHovered(widget)">
          <!-- Render grid item content here -->
          <ng-template
            [appWidgetItem]="widget"></ng-template>
        </div>
      </swiper-slide>
    }
  </swiper-container>
}


@if (!isMobileView) {
  <gridster [options]="widgetGridLayoutConfig.options" id="grid" animate.enter="adx-fade-in">
    @for (widget of widgetDataStore.widgets$ | async; track widget._id; let widgetIndex = $index) {
      <gridster-item
        [item]="widget"
        class="gridster-item"
        (mouseenter)="onWidgetHover(widget)"
        (mouseleave)="onWidgetHoverCancel(widget)"
        #widgetItems>
        @if (renderWidgetHeader(widget)) {
          <app-widget-header class="adx-grid-item-header"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed,
            'adx-header-shown': widgetHeaderIsHovered(widget)
            }"
            [widget]="widget"
            variant="grid"
            [isFullscreen]="widgetInFullscreen"
            [canToggleFullscreen]="!(widgetDataStore.edit$ | async)"
            (fullscreenToggle)="toggleFullscreen(widgetIndex)"
            (menuOpenChange)="onWidgetMenuOpenChange(widget, $event)"
            >
          </app-widget-header>
        }
        @if (showWidgetDivider(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="adx-grid-item-content" [class.adx-header-hover-mode]="widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed" [class.adx-header-overlaid]="widgetHeaderIsHovered(widget)">
          <!-- Render grid item content here -->
          <ng-template
            [appWidgetItem]="widget"></ng-template>
        </div>
      </gridster-item>
    }
  </gridster>
}
